<template>
  <table class="table text-morado-claro bg-morado-claro">
    <tbody>
      <tr class="bg-morado-claro text-morado-claro">
        <td
          class="align-middle text-center px-1 bg-morado-oscuro text-white font-weight-bold"
        >
          Nivel
        </td>
        <td
          class="align-middle text-center px-1 bg-morado-oscuro text-white font-weight-bold"
        >
          Jornada
        </td>
        <td
          class="align-middle text-center px-1 bg-morado-oscuro text-white font-weight-bold"
        >
          *Vacantes
        </td>
        <td
          class="align-middle text-center px-1 bg-morado-oscuro text-white font-weight-bold"
          style="width:20%"
        >
          Postulantes año {{ añoAnterior }}**
        </td>
      </tr>
      <!-- Iteracion sobre niveles sin especialidad -->
      <tr
        v-for="(nivel, index) in nivelesOrdenados"
        :key="index + '-dato-vacantes-' + nivel"
        :class="{
          'border-top border-3 ': tieneMargen(index),
          'border-bottom border-3 bg-morado-claro': index === niveles.length - 1
        }"
      >
        <td class="align-middle text-azul text-center px-1">
          <div
            class="btn text-morado-claro d-inline-block mx-auto d-print-none px-0"
            v-b-tooltip.hover
            :title="nivel.sexo"
          >
            <span class="align-self-center mx-auto h6"
              >{{ textoNivel(nivel.glosaNivel) }}
              <FontAwesomeIcon
                v-if="nivel.sexo === 'HOMBRES'"
                icon="male"
                class="ml-0 ml-lg-2 d-lg-inline"
              />
              <FontAwesomeIcon
                v-else-if="nivel.sexo === 'MUJERES'"
                icon="female"
                class="ml-0 ml-lg-2 d-lg-inline"
              />
              <FontAwesomeIcon
                v-else
                icon="restroom"
                class="ml-0 ml-lg-2 d-lg-inline"
              />
            </span>
          </div>
        </td>
        <td class="align-middle text-center px-1">
          {{ textoJornada(nivel.glosaJornada) }}
        </td>
        <td
          class="align-middle text-center px-1 text-morado-claro font-weight-bold"
        >
          {{
            textoVacantes(
              nivel.numeroVacantesRangoInferior
                ? nivel.numeroVacantesRangoInferior
                : 0,
              nivel.numeroVacantesRangoSuperior
                ? nivel.numeroVacantesRangoSuperior
                : 0
            )
          }}
        </td>
        <td class="align-middle text-center px-1">
          {{
            nivel.numeroPostulantesAnioAnterior
              ? nivel.numeroPostulantesAnioAnterior
              : "---"
          }}
        </td>
        <!-- <td class="align-middle text-center px-1">{{ nivel.postulantes }}</td> -->
      </tr>
      <!-- Iteracion sobre niveles con especialidad -->
      <template v-for="(value, name, index) in nivelesEspecialidad">
        <tr :key="'titulo-niveles-especialidad' + name + '-' + index">
          <td
            colspan="4"
            class="text-morado-claro gilmer text-uppercase pt-3 pb-2"
          >
            {{ "Especialidad " + name }}
          </td>
        </tr>
        <tr
          v-for="(nesp, indexN) in ordenarNiveles(value)"
          :key="
            'vacantes-niveles-especialidad' + name + '-' + index + '-' + indexN
          "
          :class="{
            'border-bottom border-3': indexN === value.length - 1
          }"
        >
          <td class="align-middle text-morado-claro text-center px-1">
            <div
              class="btn text-morado-claro d-inline-block mx-auto d-print-none px-0"
              v-b-tooltip.hover
              :title="nesp.sexo"
            >
              <span class="align-self-center mx-auto h6"
                >{{ textoNivel(nesp.glosaNivel) }}
                <FontAwesomeIcon
                  v-if="nesp.sexo === 'HOMBRES'"
                  icon="male"
                  class="ml-0 ml-lg-2 d-lg-inline"
                />
                <FontAwesomeIcon
                  v-else-if="nesp.sexo === 'MUJERES'"
                  icon="female"
                  class="ml-0 ml-lg-2 d-lg-inline"
                />
                <FontAwesomeIcon
                  v-else
                  icon="restroom"
                  class="ml-0 ml-lg-2 d-lg-inline"
                />
              </span>
            </div>
          </td>
          <td class="align-middle text-center px-1">
            {{ textoJornada(nesp.glosaJornada) }}
          </td>
          <td
            class="align-middle text-center px-1 text-morado-claro font-weight-bold"
          >
            {{
              textoVacantes(
                nesp.numeroVacantesRangoInferior
                  ? nesp.numeroVacantesRangoInferior
                  : 0,
                nesp.numeroVacantesRangoSuperior
                  ? nesp.numeroVacantesRangoSuperior
                  : 0
              )
            }}
          </td>
          <td class="align-middle text-center px-1">
            {{
              nesp.numeroPostulantesAnioAnterior
                ? nesp.numeroPostulantesAnioAnterior
                : "---"
            }}
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faRestroom,
  faMale,
  faFemale
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faRestroom, faMale, faFemale);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    niveles: {
      type: Array,
      requiered: true
    },
    nivelesEspecialidad: {
      type: Object,
      requiered: true
    }
  },
  data() {
    return {
      añoAnterior: localStorage.getItem("anioAnterior") || "default value"
    };
  },
  computed: {
    nivelesOrdenados() {
      return this.niveles.sort((a, b) => {
        if (
          this.switchNiveles(a.etiquetaNivel) >
          this.switchNiveles(b.etiquetaNivel)
        ) {
          return 1;
        } else {
          return -1;
        }
      });
    }
  },
  methods: {
    //funcion auxiliar para ordenar niveles
    switchNiveles: function(nivel) {
      switch (nivel) {
        case "PREKINDER":
          return 0;
        case "KINDER":
          return 1;
        case "1BASICO":
          return 2;
        case "2BASICO":
          return 3;
        case "3BASICO":
          return 4;
        case "4BASICO":
          return 5;
        case "5BASICO":
          return 6;
        case "6BASICO":
          return 7;
        case "7BASICO":
          return 8;
        case "8BASICO":
          return 9;
        case "1MEDIO":
          return 10;
        case "2MEDIO":
          return 11;
        case "3MEDIO":
          return 12;
        case "4MEDIO":
          return 13;
      }
    },
    //funcion para ordenar niveles
    ordenarNiveles: function(niveles) {
      return niveles.sort((a, b) => {
        if (
          this.switchNiveles(a.etiquetaNivel) >
          this.switchNiveles(b.etiquetaNivel)
        ) {
          return 1;
        } else {
          return -1;
        }
      });
    },
    // calcula texto para intervalo de vacantes
    textoVacantes: function(min, max) {
      if (min == max) {
        return min + " vacantes";
      }
      return min + " a " + max + " vacantes";
    },
    //calcula si a fila nivel le corresponde margen
    tieneMargen: function(index) {
      let arreglo = [];
      let i = 0;
      let margenBasica = -1;
      let margenMedia = -1;

      for (let n of this.niveles) {
        if (n.glosaNivel.indexOf("básico") !== -1 && i === 0) {
          margenBasica = -2;
        } else if (
          n.glosaNivel.indexOf("básico") !== -1 &&
          i !== 0 &&
          margenBasica === -1
        ) {
          margenBasica = i;
        } else if (n.glosaNivel.indexOf("medio") !== -1 && i === 0) {
          margenMedia = -2;
        } else if (
          n.glosaNivel.indexOf("medio") !== -1 &&
          i !== 0 &&
          margenMedia === -1
        ) {
          margenMedia = i;
        }
        i++;
      }
      return index === margenBasica || index === margenMedia;
    },
    //modifica el texto jornada, para que sea escrito solo con una mayuscula
    textoJornada: function(jornada) {
      return (
        jornada.substring(0, 1).toUpperCase() +
        jornada.substring(1).toLowerCase()
      );
    },
    //modifica el texto glosanivel
    textoNivel: function(nivel) {
      nivel = nivel.replace("básico", "Básico");
      nivel = nivel.replace("medio", "Medio");
      nivel = nivel.replace(
        "1er nivel de Transición (Pre-kinder)",
        "Pre-kinder"
      );
      nivel = nivel.replace("2° nivel de Transición (Kinder)", "Kinder");
      return nivel;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/derecha/TablaVacantes.vue